import logo from './logo.svg';

const PLATFORMS = [
  { 
    name: 'Admin Dashboard',
    url: 'https://admin.susicateringmedan.com',
  },
  { 
    name: 'Applikasi Gudang',
    url: 'https://ims.susicateringmedan.com',
  },
  { 
    name: 'Portal Agen',
    url: 'https://agent.susicateringmedan.com',
  },
];

function App() {
  return (
    <div className="p-10 bg-black h-[100vh] flex flex-col items-center justify-center gap-10">
      <div className="flex flex-col justify-center gap-5">
        <img src={logo} className="h-52" alt="logo" />
        <p className='text-2xl text-white text-sm'> 
          Silahkan klik untuk mengakses platform berikut :
        </p>
      </div>
      <ul className='w-full'>
        {PLATFORMS.map((item, idx) => (
        <a href={item.url} target='_blank' rel="noopener noreferrer" className='w-full text-white'>
          <li key={`platform-${idx}`} className='p-4 border border-orange-600 mt-3 rounded-full w-full text-center'>
              {item.name}
          </li>
            </a>
        ))}
      </ul>
    </div>
  );
}

export default App;
